<mat-card class="p-0 shadow">
  <mat-card-header>
    <mat-card-title>Cart Totals</mat-card-title>
  </mat-card-header>
  <hr class="p-0 mb-0 mt-0">

  <table mat-table [dataSource]="summary">
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Item </th>
      <td mat-cell *matCellDef="let line"> {{line.item}} </td>
      <td mat-footer-cell *matFooterCellDef> <span class="texy-primary-total"> Total </span> </td>
    </ng-container>

    <!-- Cost Column -->
    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef> Cost </th>
      <td mat-cell *matCellDef="let line"> {{line.cost | amount | currency}} </td>
      <td mat-footer-cell *matFooterCellDef> <span class="texy-primary-total"> {{ total | amount | currency}}
        </span></td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>

  <div class="col-md-12 text-center mb-2 mt-3 px-2">
    @if(canApplyCoupon) {
      <button mat-raised-button color="primary" class="text-center btn-checkout" (click)="proceedToCheckout()">
        Apply Coupon <mat-icon>confirmation_number</mat-icon>
      </button>
    } @else {
      <button mat-raised-button color="primary" class="text-center btn-checkout" (click)="proceedToCheckout()">
        Proceed to Checkout <mat-icon>shopping_cart_checkout</mat-icon>
      </button>
    }
    
    <button mat-button color="primary" class="mt-3" (click)="checkoutLater()"> <span class="checkout-later">Checkout Later</span></button>
  </div>
  <div class="row my-0 px-2">
    <div class="col-2 col-md-4 text-center ">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Antu_security-high.svg/512px-Antu_security-high.svg.png"
        alt="" width="95">
    </div>
    <div class="col-10 col-md-8 py-0 ps-4">
      <p><strong>SSL Secure Payment</strong></p>
      <p>Your encryption is protected by 256-bit SSL encryption</p>
    </div>
  </div>
</mat-card>
